<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { getBannerDestination, trackRMNBannerClick } from '../services/banner-utils';

  export let data: any = {};

  const { lang } = getAppConfig();
  // safe asset
  const asset = data?.creativeAsset || {};

  // multilingual handling
  const title = asset?.title?.[lang] || asset?.title?.en || '';
  const subtitle = asset?.subtitle?.[lang] || asset?.subtitle?.en || '';

  const imageUrl = asset?.bannerImageUrl || '';
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section
  class="card"
  on:click={() =>
    trackRMNBannerClick({
      bannerId: data?.adId,
      bannerName: '',
      isSponsored: true,
      bannerType: 'Shoppable Module',
      bannerDestination: getBannerDestination(data?.redirectUrl),
    })}
>
  <!-- IMAGE -->
  <div class="image-wrapper">
    <!-- svelte-ignore a11y-img-redundant-alt -->
    <img src={imageUrl} alt={title || 'banner'} />
  </div>

  <!-- CONTENT -->
  <div class="content">
    {#if title}
      <div class="title">{title}</div>
    {/if}

    {#if subtitle}
      <div class="subtitle">{subtitle}</div>
    {/if}
  </div>
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';
  .card {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    padding: 30px 10px;
    text-align: center;
    display: flex;
    gap: 16px;
    flex-direction: column;
    justify-content: space-between;
    min-width: 300px;

    background: radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.2) 0%, rgba(215, 215, 215, 0.2) 100%);
    @include desktop-max-width {
      min-width: 250px;
      padding: 24px 8px;
    }
  }

  .image-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .content {
    .title {
      font-weight: 500;
      font-size: 17px;
      color: $primary-black;
    }

    .subtitle {
      font-size: 13px;
      color: $primary-black;
    }
  }
</style>
